
import { Col, Tabs } from 'antd';

// import UserGuidesDetails from "./UserGuidesDetails";
import DocumentGuideView from "./DocumentGuideView";
import VideoGuideView from "./VideoGuideView";

const UserGuideView = () => {
    const tabItems = [
        {
            label: "Document Guides",
            key: 'document-guides',
            children: (<DocumentGuideView />),
        },
        {
            label: "Video Guides",
            key: 'video-guides',
            children: (<VideoGuideView />),
        }
    ];

    return (
        <>
            <div className="content">
                <Col xs={24}>
                    <h1 className="center-align">{"User Guides -  Management"}</h1>
                </Col>
                <Tabs defaultActiveKey="guides-material" items={tabItems} style={{marginTop: '20px'}}/>
            </div>
        </>
    )
}

export default UserGuideView;
